export default __webpack_public_path__ + "static/media/AlarmIcon.e0b0acda.svg";